
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPublicBanners, getPublicCategories, getFeaturedProducts, subscribeNewsletter  } from '../lib/api';
import { useUI } from '../context/UIContext';
import HeroSlider from '../components/home/HeroSlider';
import { BrandMarquee, StatsBar, Testimonials, RequestCTA, FeaturedBrands, TrustBar } from '../components/home/HomeComponents';
import ProductCard from '../components/shop/ProductCard';
import RecentlyViewed from '../screens/RecentlyViewed';
import { imgSrc } from '../lib/env';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

/* ── Responsive hook ── */
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [breakpoint]);
  return isMobile;
}


function useBreakpoint() {
  const getBreakpoint = () => {
    if (typeof window === 'undefined') return 'desktop';
    const w = window.innerWidth;
    if (w < 480) return 'xs';
    if (w < 768) return 'sm';
    if (w < 1024) return 'md';
    return 'desktop';
  };

  const [bp, setBp] = useState('desktop');

  useEffect(() => {
    setBp(getBreakpoint());
    const handler = () => setBp(getBreakpoint());
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return bp;
}

function ShopByCategory() {
  const navigate = useNavigate();
  const bp = useBreakpoint();
  const [cats, setCats] = useState([]);

  useEffect(() => {
    getPublicCategories().catch(() => []).then(d => setCats(Array.isArray(d) ? d.filter(c => +c.show_home) : []));
  }, []);

  if (cats.length === 0) return null;

  // const imgSrc = (url) => {
  //   if (!url) return null;
  //   if (url.startsWith('http')) return url;
  //   return 'http://localhost' + url;
  // };

  const isMobile = bp === 'xs' || bp === 'sm';
  const isTablet = bp === 'md';

  // const getGridCols = () => {
  //   if (isMobile) {
  //     return cats.length === 1 ? '1fr' : 'repeat(2, 1fr)';
  //   }
  //   if (isTablet) {
  //     return cats.length === 1 ? '1fr' : cats.length === 2 ? '1fr 1fr' : 'repeat(3, 1fr)';
  //   }
  //   return cats.length === 1 ? '1fr' : cats.length === 2 ? '1fr 1fr' : '1fr 1fr 1fr';
  // };

  // Grid columns — already correct
const getGridCols = () => {
    if (isMobile) {
        return 'repeat(2, 1fr)';  // 2×2 = all 4
    }
    if (isTablet) {
        return cats.length <= 3 ? `repeat(${cats.length}, 1fr)` : 'repeat(3, 1fr)';
    }
    return cats.length <= 3 ? `repeat(${cats.length}, 1fr)` : 'repeat(3, 1fr)';
};

  return (
    <section style={{ padding: isMobile ? '48px 16px' : isTablet ? '60px 24px' : '80px 40px', background:'#F8F5F0' }}>
      <div style={{ width: '100%', margin:'0 auto' }}>
        {/* <div style={{
          display:'flex',
          alignItems: isMobile ? 'flex-start' : 'flex-end',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent:'space-between',
          marginBottom: isMobile ? 24 : 40,
          gap: isMobile ? 12 : 0,
        }}>
          <div>
            <div style={{ fontSize:10, letterSpacing:'0.22em', textTransform:'uppercase', color:'var(--grey-mid)', fontWeight:500, marginBottom:10, fontFamily:'var(--font-body)' }}>
              Curated Edits
            </div>
            <h2 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(24px,4vw,42px)', fontWeight:300, color:'var(--dark)', letterSpacing:'-0.01em', margin:0, lineHeight:1.1 }}>
              Shop by Category
            </h2>
          </div>
          <button onClick={() => navigate('/shop')}
            style={{ background:'none', border:'none', cursor:'pointer', fontSize:13, letterSpacing:'0.18em', textTransform:'uppercase', color:'var(--dark)', fontWeight:600, fontFamily:'var(--font-body)', textDecoration:'underline', textUnderlineOffset:4, paddingBottom:2, whiteSpace:'nowrap' }}>
            View All Collections
          </button>
        </div> */}
        <div style={{
  display:'flex',
  alignItems: 'flex-end',       // always flex-end so button aligns to bottom of title
  flexDirection: 'row',         // always row — side by side on all screens
  justifyContent:'space-between',
  marginBottom: isMobile ? 24 : 40,
  gap: 12,
}}>
  <div>
    <div style={{ fontSize:10, letterSpacing:'0.22em', textTransform:'uppercase', color:'var(--grey-mid)', fontWeight:500, marginBottom:10, fontFamily:'var(--font-body)' }}>
      Curated Edits
    </div>
    <h2 style={{ fontFamily:'var(--font-display)', fontSize: isMobile ? 'clamp(18px,5vw,28px)' : 'clamp(24px,4vw,42px)', fontWeight:300, color:'var(--dark)', letterSpacing:'-0.01em', margin:0, lineHeight:1.1 }}>
      Shop by Category
    </h2>
  </div>
  <button onClick={() => navigate('/shop')}
    style={{ background:'none', border:'none', cursor:'pointer', fontSize: isMobile ? 10 : 13, letterSpacing:'0.18em', textTransform:'uppercase', color:'var(--dark)', fontWeight:600, fontFamily:'var(--font-body)', textDecoration:'underline', textUnderlineOffset:4, paddingBottom:2, whiteSpace:'nowrap', flexShrink:0 }}>
    View All Collections
  </button>
</div>

        {/* Grid */}
<div style={{ display:'grid', gridTemplateColumns: getGridCols(), gap: isMobile ? 10 : 16 }}>
    {/* Mobile: show all 4 | Desktop/Tablet: show only first 3 */}
    {(isMobile ? cats : cats.slice(0, 3)).map(cat => (
        <div key={cat.id}
            onClick={() => navigate(`/shop?category=${encodeURIComponent(cat.name)}`)}
            style={{ position:'relative', cursor:'pointer', overflow:'hidden' }}
            onMouseEnter={e => { const img = e.currentTarget.querySelector('.cat-img'); if (img) img.style.transform = 'scale(1.04)'; }}
            onMouseLeave={e => { const img = e.currentTarget.querySelector('.cat-img'); if (img) img.style.transform = 'scale(1)'; }}>
            <div style={{ aspectRatio:'3/4', overflow:'hidden', background:'#e8e4df' }}>
                {imgSrc(cat.img)
                    ? <img className="cat-img" src={imgSrc(cat.img)} alt={cat.name}
                        style={{ width:'100%', height:'100%', objectFit:'cover', transition:'transform 0.6s ease', display:'block' }} />
                    : <div style={{ width:'100%', height:'100%', background:'#d4c5b0', display:'flex', alignItems:'center', justifyContent:'center' }}>
                        <span style={{ fontSize:48, opacity:0.3 }}>👜</span>
                      </div>
                }
            </div>
            <div style={{ position:'absolute', bottom:0, left:0, right:0, background:'linear-gradient(to top, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0) 60%)', padding:'40px 20px 22px', textAlign:'center' }}>
                <div style={{ fontFamily:'var(--font-display)', fontSize: isMobile ? 'clamp(14px,4vw,22px)' : 'clamp(18px,2.5vw,36px)', fontWeight:400, color:'#fff', letterSpacing:'0.02em', marginBottom:5 }}>
                    {cat.name}
                </div>
                <div style={{ fontSize:10, letterSpacing:'0.22em', textTransform:'uppercase', color:'rgba(255,255,255,0.65)', fontWeight:600, fontFamily:'var(--font-body)' }}>
                    Discover
                </div>
            </div>
        </div>
    ))}
</div>

      </div>
    </section>
  );
}

/* ── Sell Your Piece CTA ── */
function SellCTA() {
  const navigate = useNavigate();
  const bp = useBreakpoint();
  const isMobile = bp === 'xs' || bp === 'sm';
  const isTablet = bp === 'md';

  return (
    <section style={{ background: '#F8F5F0', padding: isMobile ? '0 16px 48px' : isTablet ? '0 24px 60px' : '0 0px 0px' }}>
      <div style={{ width: '100%', margin: '0 auto' }}>
        <div style={{
          background: 'var(--dark)',
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
          overflow: 'hidden',
          minHeight: isMobile ? 'auto' : 260,
        }}>
          {/* Left — text */}
          <div style={{
            padding: isMobile ? '36px 24px' : isTablet ? '40px 36px' : '52px 56px',
            display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 16,
          }}>
            <div style={{ fontSize: 10, letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--gold)', fontWeight: 600, fontFamily: 'var(--font-body)' }}>
              Consignment Service
            </div>
            <h2 style={{
              fontFamily: 'var(--font-display)', fontSize: isMobile ? 'clamp(22px,6vw,32px)' : 'clamp(26px,3.5vw,40px)',
              fontWeight: 300, color: '#fff', letterSpacing: '-0.01em',
              lineHeight: 1.15, margin: 0,
            }}>
              Have a Luxury Piece<br />to Sell?
            </h2>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)', lineHeight: 1.75, maxWidth: 360, margin: 0, fontWeight: 300, fontFamily: 'var(--font-body)' }}>
              We authenticate, value and sell your designer items — with full transparency, fair pricing and white-glove care.
            </p>
            <div style={{
  display: 'flex',
  gap: 10,
  marginTop: 8,
  flexDirection: isMobile ? 'column' : 'row', /* ✅ column on mobile, row on desktop */
}}>
  <button
    onClick={() => navigate('/sell')}
    style={{
      padding: isMobile ? '14px 24px' : '13px 32px',
      background: 'var(--gold)',
      color: 'var(--dark)',
      border: 'none',
      cursor: 'pointer',
      fontSize: 10,
      letterSpacing: '0.22em',
      textTransform: 'uppercase',
      fontWeight: 700,
      fontFamily: 'var(--font-body)',
      transition: 'background 0.25s',
      width: isMobile ? '100%' : 'auto', /* ✅ full width on mobile */
    }}
    onMouseEnter={e => e.currentTarget.style.background = '#b8992a'}
    onMouseLeave={e => e.currentTarget.style.background = 'var(--gold)'}>
    Sell Your Piece →
  </button>

  <button
    onClick={() => navigate('/sell')}
    style={{
      padding: isMobile ? '14px 24px' : '13px 32px',
      background: 'transparent',
      color: 'rgba(255,255,255,0.65)',
      border: '1px solid rgba(255,255,255,0.2)',
      cursor: 'pointer',
      fontSize: 10,
      letterSpacing: '0.22em',
      textTransform: 'uppercase',
      fontWeight: 600,
      fontFamily: 'var(--font-body)',
      transition: 'all 0.25s',
      width: isMobile ? '100%' : 'auto', /* ✅ full width on mobile */
    }}
    onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)'; e.currentTarget.style.color = '#fff'; }}
    onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'; e.currentTarget.style.color = 'rgba(255,255,255,0.65)'; }}>
    Learn More
  </button>
</div>
          </div>

          {/* Right — 3 steps */}
          <div style={{
            background: 'rgba(255,255,255,0.04)',
            borderLeft: isMobile ? 'none' : '1px solid rgba(255,255,255,0.08)',
            borderTop: isMobile ? '1px solid rgba(255,255,255,0.08)' : 'none',
            display: 'flex', flexDirection: 'column', justifyContent: 'center',
            padding: isMobile ? '32px 24px' : '40px 52px', gap: 28,
          }}>
            {[
              { n: '01', title: 'Submit Photos',  desc: 'Upload images of your piece from multiple angles.' },
              { n: '02', title: 'We Evaluate',    desc: 'Expert authentication and fair market valuation.' },
              { n: '03', title: 'You Get Paid',   desc: 'We sell it, you receive your agreed amount.' },
            ].map((step) => (
              <div key={step.n} style={{ display: 'flex', gap: 20, alignItems: 'flex-start' }}>
                <div style={{
                  fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 300,
                  color: 'var(--gold)', opacity: 0.5, lineHeight: 1, flexShrink: 0, width: 32,
                }}>
                  {step.n}
                </div>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#fff', fontFamily: 'var(--font-body)', marginBottom: 4 }}>
                    {step.title}
                  </div>
                  <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.38)', lineHeight: 1.6, fontFamily: 'var(--font-body)' }}>
                    {step.desc}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const isMobile = useIsMobile();

  async function handleSubmit(e) {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    try {
      await subscribeNewsletter(email);
      setStatus('success');
      setEmail('');
    } catch {
      setStatus('error');
    }
  }

  return (
    <section style={{ background: 'var(--cream)', padding: isMobile ? '48px 16px' : '80px 40px' }}>
      <div style={{ maxWidth: 480, margin: '0 auto', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, padding: isMobile ? '0 8px' : '0' }}>
        <svg width={32} height={32} fill="none" stroke="var(--gold)" strokeWidth={1.4} viewBox="0 0 24 24">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
        <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(24px,6vw,38px)', fontWeight: 300, color: 'var(--dark)', letterSpacing: '-0.01em', margin: 0 }}>
          Join The List
        </h2>
        <p style={{ fontSize: 14, color: 'var(--grey-mid)', lineHeight: 1.75, maxWidth: 500, margin: 0, fontWeight: 300 }}>
          Subscribe to receive updates on exclusive imports, private sales, and the latest from the world of luxury.
        </p>
        {status === 'success' ? (
          <div style={{ padding: '16px 32px', background: '#dcfce7', border: '1px solid #bbf7d0', color: '#166534', fontSize: 13, letterSpacing: '0.05em' }}>
            ✓ You're on the list. Welcome.
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: 400, display: 'flex', flexDirection: 'column', gap: 9 }}>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="Email Address" required
              style={{
                width: '100%', padding: '16px 20px', border: '2px solid #D1D5DB',
                fontSize: 13, color: '#D1D5DB', outline: 'none', textAlign: 'center',
                fontFamily: 'var(--font-body)', boxSizing: 'border-box',
                letterSpacing: '0.04em', background: 'transparent',
              }}
              onBlur={e => e.target.style.borderColor = 'var(--grey)'}
            />
            <button type="submit" disabled={status === 'loading'}
              style={{
                width: '100%', padding: '15px 20px', background: 'var(--dark)', color: '#fff',
                border: '1px solid var(--dark)', fontSize: 10, letterSpacing: '0.22em',
                textTransform: 'uppercase', fontWeight: 700,
                cursor: status === 'loading' ? 'wait' : 'pointer',
                fontFamily: 'var(--font-body)', transition: 'background 0.25s',
                opacity: status === 'loading' ? 0.7 : 1,
              }}
              onMouseEnter={e => { if (status !== 'loading') { e.currentTarget.style.background = 'var(--gold)'; e.currentTarget.style.borderColor = 'var(--gold)'; } }}
              onMouseLeave={e => { e.currentTarget.style.background = 'var(--dark)'; e.currentTarget.style.borderColor = 'var(--dark)'; }}>
              {status === 'loading' ? 'Subscribing…' : 'Subscribe'}
            </button>
            {status === 'error' && (
              <p style={{ fontSize: 11, color: 'var(--red)', marginTop: 8, textAlign: 'center' }}>
                Something went wrong. Please try again.
              </p>
            )}
          </form>
        )}
      </div>
    </section>
  );
}

function SkeletonGrid({ n = 4, cols = 4 }) {
  return (
    <div style={{ display:'grid', gridTemplateColumns:`repeat(${cols},1fr)`, gap: cols <= 2 ? 12 : 24 }}>
      {Array.from({ length: n }).map((_, i) => (
        <div key={i} className="animate-pulse">
          <div style={{ aspectRatio:'3/4', background:'var(--grey)' }} />
          <div style={{ height:11, background:'var(--grey)', width:'55%', margin:'14px auto 8px' }} />
          <div style={{ height:11, background:'var(--grey)', width:'38%', margin:'0 auto' }} />
        </div>
      ))}
    </div>
  );
}

export default function HomePage() {
  const [featured, setFeatured] = useState([]);
  // const [banners,  setBanners]  = useState([]);
  const [banners,  setBanners]  = useState(null);
  const [loading,  setLoading]  = useState(true);
  const { openEnquiry } = useUI();
  const navigate = useNavigate();
  const bp = useBreakpoint();
  useScrollAnimation();

  const isMobile = bp === 'xs' || bp === 'sm';
  const isTablet = bp === 'md';

  // Determine product grid columns
  const productCols = isMobile ? 2 : isTablet ? 3 : 4;
  const productGap  = isMobile ? 12 : 24;

  useEffect(() => {
    Promise.all([
      getFeaturedProducts().catch(() => []),
      getPublicBanners().catch(() => []),
    ]).then(([feat, bans]) => {
      setFeatured(Array.isArray(feat) ? feat : []);
      setBanners(Array.isArray(bans) ? bans.filter(b => b.active) : []);
    }).finally(() => setLoading(false));
  }, []);

  return (
    <>
      <HeroSlider banners={banners} />
      <TrustBar />
      {/* <ShopByCategory /> */}
      <div data-animate="fade-up">
        <ShopByCategory />
      </div>

      {/* Featured products — The House Selection */}
      <section data-animate="fade-up" style={{ padding: isMobile ? '48px 16px' : isTablet ? '60px 24px' : '80px 40px', background:'#fff' }}>
        <div style={{ width: '100%', margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom: isMobile ? 32 : 52 }}>
            <div style={{ fontSize:12, letterSpacing:'0.22em', textTransform:'uppercase', color:'var(--grey-mid)', fontWeight:500, marginBottom:14, fontFamily:'var(--font-body)' }}>
              Latest Arrivals
            </div>
            <h2 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(28px,5vw,52px)', fontWeight:300, color:'var(--dark)', letterSpacing:'-0.02em', margin:0 }}>
              The House Selection
            </h2>
          </div>

          {loading ? (
            <SkeletonGrid n={productCols * 2} cols={productCols} />
          ) : featured.length === 0 ? (
            <p style={{ textAlign:'center', color:'var(--grey-mid)', fontSize:14, padding:'60px 0' }}>No featured products yet.</p>
          ) : (
            <div style={{ display:'grid', gridTemplateColumns:`repeat(${productCols},1fr)`, gap: productGap }}>
              {featured.map(p => <ProductCard key={p.id} product={p} />)}
            </div>
          )}

          {!loading && featured.length > 0 && (
            <div style={{ textAlign:'center', marginTop: isMobile ? 32 : 52 }}>
              <button
                onClick={() => navigate('/shop')}
                style={{
                  padding: isMobile ? '13px 32px' : '14px 48px', background:'transparent',
                  border:'1px solid var(--dark)', color:'var(--dark)',
                  fontSize:12, letterSpacing:'0.22em', textTransform:'uppercase',
                  fontWeight:500, cursor:'pointer', fontFamily:'var(--font-body)',
                  transition:'all 0.3s', width: isMobile ? '100%' : 'auto',
                }}
                onMouseEnter={e => { e.currentTarget.style.background='var(--dark)'; e.currentTarget.style.color='#fff'; }}
                onMouseLeave={e => { e.currentTarget.style.background='transparent'; e.currentTarget.style.color='var(--dark)'; }}>
                View Complete Collection
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Recently Viewed */}

      <div data-animate="fade-left">
        <RecentlyViewed />
      </div>

      <div data-animate="fade-up">
        <SellCTA />
      </div>

      <NewsletterSection />
      <Testimonials />
      <StatsBar />
      <RequestCTA onOpen={openEnquiry} />
    </>
  );
}


// import { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   getPublicBanners,
//   getPublicCategories,
//   getFeaturedProducts,
//   subscribeNewsletter,
// } from '../lib/api';
// import { useUI } from '../context/UIContext';
// import HeroSlider from '../components/home/HeroSlider';
// import {
//   StatsBar,
//   Testimonials,
//   RequestCTA,
//   TrustBar,
// } from '../components/home/HomeComponents';
// import ProductCard from '../components/shop/ProductCard';
// import RecentlyViewed from '../screens/RecentlyViewed';
// import { imgSrc } from '../lib/env';
// import { useScrollAnimation } from '../hooks/useScrollAnimation';

// /* ─────────────────────────────────────────────
//    Hooks
// ───────────────────────────────────────────── */
// function useBreakpoint() {
//   const get = () => {
//     if (typeof window === 'undefined') return 'desktop';
//     const w = window.innerWidth;
//     if (w < 480) return 'xs';
//     if (w < 768) return 'sm';
//     if (w < 1024) return 'md';
//     return 'desktop';
//   };
//   const [bp, setBp] = useState('desktop');
//   useEffect(() => {
//     setBp(get());
//     const h = () => setBp(get());
//     window.addEventListener('resize', h);
//     return () => window.removeEventListener('resize', h);
//   }, []);
//   return bp;
// }

// function useIsMobile(bp = 768) {
//   const [v, setV] = useState(
//     typeof window !== 'undefined' ? window.innerWidth < bp : false
//   );
//   useEffect(() => {
//     const h = () => setV(window.innerWidth < bp);
//     window.addEventListener('resize', h);
//     return () => window.removeEventListener('resize', h);
//   }, [bp]);
//   return v;
// }

// /* ─────────────────────────────────────────────
//    SkeletonGrid
// ───────────────────────────────────────────── */
// function SkeletonGrid({ n = 4, cols = 4 }) {
//   return (
//     <div
//       className="grid gap-3 md:gap-6"
//       style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}
//     >
//       {Array.from({ length: n }).map((_, i) => (
//         <div key={i} className="animate-pulse">
//           <div className="aspect-[3/4] bg-[var(--grey)]" />
//           <div className="h-[11px] bg-[var(--grey)] w-[55%] mx-auto mt-3.5 mb-2" />
//           <div className="h-[11px] bg-[var(--grey)] w-[38%] mx-auto" />
//         </div>
//       ))}
//     </div>
//   );
// }

// /* ─────────────────────────────────────────────
//    ShopByCategory
// ───────────────────────────────────────────── */
// function ShopByCategory() {
//   const navigate = useNavigate();
//   const bp       = useBreakpoint();
//   const [cats, setCats] = useState([]);

//   useEffect(() => {
//     getPublicCategories()
//       .catch(() => [])
//       .then(d => setCats(Array.isArray(d) ? d.filter(c => +c.show_home) : []));
//   }, []);

//   if (cats.length === 0) return null;

//   const isMobile    = bp === 'xs' || bp === 'sm';
//   // Mobile: show all (2×2 grid); Tablet/Desktop: first 3
//   const displayCats = isMobile ? cats : cats.slice(0, 3);

//   return (
//     <section className="aurora-section bg-[#F8F5F0]">
//       <div className="aurora-container">

//         {/* Header row */}
//         <div className="flex items-end justify-between mb-6 md:mb-10 gap-3">
//           <div>
//             <p className="aurora-eyebrow">Curated Edits</p>
//             <h2 className="aurora-heading-lg">Shop by Category</h2>
//           </div>
//           <button
//             onClick={() => navigate('/shop')}
//             className="aurora-link-btn flex-shrink-0"
//           >
//             View All Collections
//           </button>
//         </div>

//         {/* Grid — 2 cols on mobile, 3 on tablet/desktop */}
//         <div className="grid grid-cols-2 md:grid-cols-3 gap-2.5 md:gap-4">
//           {displayCats.map(cat => (
//             <div
//               key={cat.id}
//               onClick={() => navigate(`/shop?category=${encodeURIComponent(cat.name)}`)}
//               className="relative cursor-pointer overflow-hidden group"
//             >
//               <div className="aspect-[3/4] overflow-hidden bg-[#e8e4df]">
//                 {imgSrc(cat.img) ? (
//                   <img
//                     src={imgSrc(cat.img)}
//                     alt={cat.name}
//                     className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
//                   />
//                 ) : (
//                   <div className="w-full h-full bg-[#d4c5b0] flex items-center justify-center">
//                     <span className="text-5xl opacity-30">👜</span>
//                   </div>
//                 )}
//               </div>

//               {/* Overlay label */}
//               <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/55 to-transparent px-5 pb-5 pt-10 text-center">
//                 <div className="font-display text-[clamp(14px,4vw,36px)] font-normal text-white tracking-wide mb-1">
//                   {cat.name}
//                 </div>
//                 <div className="text-[10px] tracking-[0.22em] uppercase text-white/65 font-semibold font-body">
//                   Discover
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// }

// /* ─────────────────────────────────────────────
//    SellCTA
// ───────────────────────────────────────────── */
// function SellCTA() {
//   const navigate = useNavigate();
//   const bp       = useBreakpoint();
//   const isMobile = bp === 'xs' || bp === 'sm';

//   const STEPS = [
//     { n: '01', title: 'Submit Photos',  desc: 'Upload images of your piece from multiple angles.' },
//     { n: '02', title: 'We Evaluate',    desc: 'Expert authentication and fair market valuation.' },
//     { n: '03', title: 'You Get Paid',   desc: 'We sell it, you receive your agreed amount.' },
//   ];

//   return (
//     <section className={`bg-[#F8F5F0] ${isMobile ? 'px-4 pb-12' : 'pb-0'}`}>
//       <div className="w-full">
//         <div className="bg-[var(--dark)] grid grid-cols-1 md:grid-cols-2 overflow-hidden min-h-[260px]">

//           {/* Left — text */}
//           <div className="flex flex-col justify-center gap-4 p-9 md:p-14">
//             <p className="text-[10px] tracking-[0.3em] uppercase text-[var(--gold)] font-semibold font-body">
//               Consignment Service
//             </p>
//             <h2 className="font-display text-[clamp(22px,6vw,40px)] font-light text-white leading-[1.15] tracking-tight">
//               Have a Luxury Piece<br />to Sell?
//             </h2>
//             <p className="text-[13px] text-white/45 leading-[1.75] max-w-sm font-light font-body">
//               We authenticate, value and sell your designer items — with full
//               transparency, fair pricing and white-glove care.
//             </p>
//             <div className="flex flex-col md:flex-row gap-2.5 mt-2">
//               <button
//                 onClick={() => navigate('/sell')}
//                 className="aurora-btn-gold w-full md:w-auto"
//               >
//                 Sell Your Piece →
//               </button>
//               <button
//                 onClick={() => navigate('/sell')}
//                 className="aurora-btn-ghost-white w-full md:w-auto"
//               >
//                 Learn More
//               </button>
//             </div>
//           </div>

//           {/* Right — 3 steps */}
//           <div className="flex flex-col justify-center gap-7 p-8 md:p-13 bg-white/[0.04] border-t border-white/[0.08] md:border-t-0 md:border-l md:border-white/[0.08]">
//             {STEPS.map(step => (
//               <div key={step.n} className="flex gap-5 items-start">
//                 <div className="font-display text-[22px] font-light text-[var(--gold)] opacity-50 leading-none flex-shrink-0 w-8">
//                   {step.n}
//                 </div>
//                 <div>
//                   <div className="text-[11px] font-semibold tracking-[0.12em] uppercase text-white font-body mb-1">
//                     {step.title}
//                   </div>
//                   <div className="text-[12px] text-white/[0.38] leading-[1.6] font-body">
//                     {step.desc}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// }

// /* ─────────────────────────────────────────────
//    NewsletterSection
// ───────────────────────────────────────────── */
// function NewsletterSection() {
//   const [email, setEmail]   = useState('');
//   const [status, setStatus] = useState('idle');
//   const isMobile            = useIsMobile();

//   async function handleSubmit(e) {
//     e.preventDefault();
//     if (!email) return;
//     setStatus('loading');
//     try {
//       await subscribeNewsletter(email);
//       setStatus('success');
//       setEmail('');
//     } catch {
//       setStatus('error');
//     }
//   }

//   return (
//     <section className="bg-[var(--cream)] py-12 md:py-20 px-4 md:px-10">
//       <div className="max-w-lg mx-auto text-center flex flex-col items-center gap-4">

//         <svg width={32} height={32} fill="none" stroke="var(--gold)" strokeWidth={1.4} viewBox="0 0 24 24">
//           <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
//           <polyline points="22,6 12,13 2,6" />
//         </svg>

//         <h2 className="font-display text-[clamp(24px,6vw,38px)] font-light text-[var(--dark)] tracking-tight">
//           Join The List
//         </h2>
//         <p className="text-[14px] text-[var(--grey-mid)] leading-[1.75] max-w-md font-light font-body">
//           Subscribe to receive updates on exclusive imports, private sales, and
//           the latest from the world of luxury.
//         </p>

//         {status === 'success' ? (
//           <div className="px-8 py-4 bg-green-50 border border-green-200 text-green-800 text-[13px] tracking-wide">
//             ✓ You're on the list. Welcome.
//           </div>
//         ) : (
//           <form onSubmit={handleSubmit} className="w-full max-w-sm flex flex-col gap-2">
//             <input
//               type="email"
//               value={email}
//               onChange={e => setEmail(e.target.value)}
//               placeholder="Email Address"
//               required
//               className="w-full px-5 py-4 border-2 border-gray-300 bg-transparent text-[13px] text-gray-400 outline-none text-center font-body tracking-wide transition-colors focus:border-[var(--dark)]"
//             />
//             <button
//               type="submit"
//               disabled={status === 'loading'}
//               className="w-full py-4 bg-[var(--dark)] text-white text-[10px] tracking-[0.22em] uppercase font-bold font-body border border-[var(--dark)] transition-colors hover:bg-[var(--gold)] hover:border-[var(--gold)] disabled:opacity-70"
//             >
//               {status === 'loading' ? 'Subscribing…' : 'Subscribe'}
//             </button>
//             {status === 'error' && (
//               <p className="text-[11px] text-[var(--red)] mt-2 text-center font-body">
//                 Something went wrong. Please try again.
//               </p>
//             )}
//           </form>
//         )}
//       </div>
//     </section>
//   );
// }

// /* ─────────────────────────────────────────────
//    HomePage (main export)
// ───────────────────────────────────────────── */
// export default function HomePage() {
//   const [featured, setFeatured] = useState([]);
//   const [banners,  setBanners]  = useState(null);
//   const [loading,  setLoading]  = useState(true);
//   const { openEnquiry } = useUI();
//   const navigate        = useNavigate();
//   const bp              = useBreakpoint();
//   useScrollAnimation();

//   const isMobile    = bp === 'xs' || bp === 'sm';
//   const isTablet    = bp === 'md';
//   const productCols = isMobile ? 2 : isTablet ? 3 : 4;

//   useEffect(() => {
//     Promise.all([
//       getFeaturedProducts().catch(() => []),
//       getPublicBanners().catch(() => []),
//     ]).then(([feat, bans]) => {
//       setFeatured(Array.isArray(feat) ? feat : []);
//       setBanners(Array.isArray(bans) ? bans.filter(b => b.active) : []);
//     }).finally(() => setLoading(false));
//   }, []);

//   return (
//     <>
//       <HeroSlider banners={banners} />
//       <TrustBar />

//       <div data-animate="fade-up">
//         <ShopByCategory />
//       </div>

//       {/* Featured — The House Selection */}
//       <section data-animate="fade-up" className="aurora-section bg-white">
//         <div className="aurora-container">

//           <div className="text-center mb-8 md:mb-14">
//             <p className="aurora-eyebrow">Latest Arrivals</p>
//             <h2 className="font-display text-[clamp(28px,5vw,52px)] font-light text-[var(--dark)] tracking-[-0.02em]">
//               The House Selection
//             </h2>
//           </div>

//           {loading ? (
//             <SkeletonGrid n={productCols * 2} cols={productCols} />
//           ) : featured.length === 0 ? (
//             <p className="text-center text-[var(--grey-mid)] text-[14px] py-16 font-body">
//               No featured products yet.
//             </p>
//           ) : (
//             <div
//               className="grid gap-3 md:gap-6"
//               style={{ gridTemplateColumns: `repeat(${productCols}, 1fr)` }}
//             >
//               {featured.map(p => <ProductCard key={p.id} product={p} />)}
//             </div>
//           )}

//           {!loading && featured.length > 0 && (
//             <div className="text-center mt-8 md:mt-14">
//               <button
//                 onClick={() => navigate('/shop')}
//                 className="aurora-btn-outline w-full md:w-auto"
//               >
//                 View Complete Collection
//               </button>
//             </div>
//           )}

//         </div>
//       </section>

//       <div data-animate="fade-left">
//         <RecentlyViewed />
//       </div>

//       <div data-animate="fade-up">
//         <SellCTA />
//       </div>

//       <NewsletterSection />
//       <Testimonials />
//       <StatsBar />
//       <RequestCTA onOpen={openEnquiry} />
//     </>
//   );
// }